module.exports = __webpack_public_path__ + "static/img/LOGO.5e9ce2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/LOGO.png
// module id = Bzji
// module chunks = 5